module.exports = __webpack_public_path__ + "static/media/live.53f97355.svg";